import { OOTBRequest } from '@escon/utils';
import { logout } from './utils';
import { ElMessage } from 'element-plus';

const request = OOTBRequest({
  showMessage(msg) {
    ElMessage.error(msg);
  },
  gotoLogin() {
    logout();
    location.href = `${location.origin}${location.pathname}#/login`;
  },
});

export default request;
